import { useStagingAuth } from './useStagingAuth'
import { StagingLogin } from './StagingLogin'

interface StagingGateProps {
  children: React.ReactNode
}

export const StagingGate: React.FC<StagingGateProps> = ({ children }) => {
  const { authed, isLoading, setAuthed } = useStagingAuth()

  // Show dark gray background while checking authentication status
  if (isLoading) {
    return <div className="fixed inset-0 bg-gray-800" />
  }

  if (!authed) {
    return <StagingLogin onAuthenticated={() => setAuthed(true)} />
  }

  return <>{children}</>
}
